
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import classNames from 'classnames/bind';
import CorporateCulture from 'components/career/CorporateCulture';
import HowWeWorkSection from 'components/career/HowWeWorkSection';
import CareerSection from 'components/home/CareerSection';
import { Locale } from 'constants/locale';
import useWindowSize from 'hooks/useWindowSize';
import { useRouter } from 'next/router';
import styles from 'styles/Career.module.css';
import { Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';
import { toLocale } from 'utils/locale';
const cx = classNames.bind(styles);
const CORPORATE_CULTURE_LOCALES: Locale[] = ['ko', 'ja'];
function Career() {
    const { width } = useWindowSize();
    const isMobile = width ? width <= 780 : false;
    const router = useRouter();
    const { locale } = router;
    return (<>
      <div className={cx('main-image')}/>
      <HowWeWorkSection />
      <div className={cx('swiper-container')}>
        <Swiper grabCursor={true} slidesPerView={isMobile ? 2 : 3} spaceBetween={32} modules={[Pagination]} pagination={true}>
          <SwiperSlide className={cx('swiper-wrapper')}>
            <div className={cx('swiper-image-01')}/>
          </SwiperSlide>
          <SwiperSlide className={cx('swiper-wrapper')}>
            <div className={cx('swiper-image-02')}/>
          </SwiperSlide>
          <SwiperSlide className={cx('swiper-wrapper')}>
            <div className={cx('swiper-image-03')}/>
          </SwiperSlide>
          <SwiperSlide className={cx('swiper-wrapper')}>
            <div className={cx('swiper-image-04')}/>
          </SwiperSlide>
          <SwiperSlide className={cx('swiper-wrapper')}>
            <div className={cx('swiper-image-05')}/>
          </SwiperSlide>
        </Swiper>
      </div>
      {CORPORATE_CULTURE_LOCALES.includes(toLocale(locale)) && (<>
          <CorporateCulture />
          <CareerSection />
        </>)}
    </>);
}
export default Career;

    async function __Next_Translate__getStaticProps__1a181b93476__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/career/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a181b93476__ as getStaticProps }
  